import {
  ContentContainer,
  PageHeader,
  Breadcrumb,
  LoadingSkeleton,
  Grid,
} from "@twinkltech/curriculum-architect-component-library";
import { useTranslation } from "react-i18next";

import { SkeletonCard } from "@/components/SkeletonCard/SkeletonCard";

import { COMMON_NS } from "@/i18n/common/common.i18n";

export const LoadingPage = () => {
  const { t } = useTranslation(COMMON_NS);
  return (
    <>
      <ContentContainer bottomPadding="none">
        <PageHeader>
          <PageHeader.Breadcrumb>
            <Breadcrumb.Item>
              <LoadingSkeleton height="1.5rem" width="320px" />
            </Breadcrumb.Item>
          </PageHeader.Breadcrumb>
          <PageHeader.Title>
            <>
              <h1 className="sr-only">
                {t("actions.loading", { ns: COMMON_NS })}
              </h1>
              <LoadingSkeleton
                aria-label="loading heading"
                height="4.5rem"
                width="350px"
              />
            </>
          </PageHeader.Title>
        </PageHeader>
      </ContentContainer>
      <ContentContainer topPadding="none" width="x-large">
        <Grid
          cols={{
            sm: 1,
            md: 2,
          }}
        >
          {Array.from({ length: 6 }).map((_, index) => (
            <SkeletonCard key={index} />
          ))}
        </Grid>
      </ContentContainer>
    </>
  );
};
